export default __webpack_public_path__ + "static/media/open-eye.e4181c4f.svg";